export const currentUserPlaceholder = '~~User~~';
